module.exports = __webpack_public_path__ + "img/1F3F4-E0075-E0073-E0063-E0061-E007F.24e87f26.svg";